import React, {Component} from 'react';
import {InputNumber} from 'antd';
import FieldError from './FieldError';

class SAInputDistance extends Component {
  render() {
    const {
      error,
      className,
      name,
      onChange,
      placeholder,
      value,
      step,
      ...attributes
    } = this.props;
    const errorClassName = error ? ' error' : '';

    return (
      <span className={`${errorClassName} ${className}`}>
        <InputNumber
          name={name}
          id={name}
          placeholder={placeholder}
          value={value}
          min={0}
          step={step || 10}
          formatter={value => `${value}Km`}
          parser={value => value.replace('Km', '')}
          onChange={onChange}
          {...attributes}
        />
        <br />
        {error && <FieldError error={error} />}
      </span>
    );
  }
}

export default SAInputDistance;



// WEBPACK FOOTER //
// ./src/components/common/input/SAInputDistance.js